// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"31ca9546","559":"8be30fb0","620":"33f5104a"}[chunkId] + ".chunk.js";
};